<template>
  <div class="side-box" :class="{ active: opened.length > 0 }">
    <span class="side-box__overlay" />
    <div
      class="side-box__inner"
      :class="{
        opened: opened.indexOf('appendService') >= 0,
        'last-active': opened.indexOf('appendService') == opened.length - 1
      }"
    >
      <div
        class="side-box__header d-flex justify-content-between align-items-center"
      >
        <div class="atom-back atom-back--gray" @click="toggleConfirmation()">
          <div class="atom-back__inner d-flex align-items-center">
            <img src="@/assets/icons/arrows/arr-gray-left.svg" /><span>{{
              $t("zpet")
            }}</span>
          </div>
        </div>
        <button class="btn btn-primary" @click="runEdit()">
          <div class="atom-icon">
            <img src="@/assets/icons/actions/ico-btn-ulozit.svg" />
          </div>
          {{ $t("ulozit") }}
        </button>
      </div>
      <div class="side-box__title">
        <h2 v-if="services.length > 0">
          {{ $t("priradit") }}
          <span
            v-if="services.length > 1 && services.length < 5"
          >{{ services.length }} {{ $t("sluzby") }}</span><span
            v-else-if="services.length > 5"
          >{{ services.length }} {{ $t("sluzbam") }}</span><span
            v-else
          >{{ $t("sluzbu") }} {{ services[0].custServiceName }}</span>
          {{ $t("kProjektu") }}
        </h2>
      </div>
      <div v-if="projects" class="side-box__content">
        <div class="my-4">
          <FormSelectMultiple
            :items="projects"
            :label="$t('vyberteProjekt')"
            :placeholder="$t('SELECT_PROJECT_FROM_LIST')"
            :value="selectedProjects"
            class="mb-3"
            item-text="projectName"
            item-value="projectId"
            side-box
            @change="selectedProjects = $event"
          />
        </div>
      </div>
    </div>
    <save-confirmation-modal
      :opened="openedConfirmation"
      :text="'chceteUlozitProvedeneZmeny'"
      @yes="runSave()"
      @no="closeBox('appendService')"
      @close="toggleConfirmation"
    />
    <div v-if="errorsToTranslate.length > 0">
      <error-modal
        :opened="openedError"
        :centered="true"
        :errors="errorsToTranslate"
        @close="
          openedError = false;
          $emit('closeBox', 'appendService');
        "
      />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import ErrorModal from "@/components/confirmations/translatedErrors.vue";
import SaveConfirmationModal from "@/components/confirmations/save.vue";
import FormSelectMultiple from "@/components/forms/FormSelectMultiple.vue";
import { useAdminStore } from "@/store/modules/admin"
export default {
  components: {
    FormSelectMultiple,
    "save-confirmation-modal": SaveConfirmationModal,
    "error-modal": ErrorModal
  },
  props: {
    services: Array,
    opened: Array
  },
  setup() {
    const adminStore = useAdminStore()
    return { adminStore }
  },
  data() {
    return {
      projects: [],
      selectedProjects: [],
      projectsOpened: false,
      selectProjectVisible: false,
      openedError: false,
      errorsToTranslate: [],
      openedConfirmation: false
    };
  },
  computed: {
    storedCustomer() {
      return this.adminStore.customer
    }
  },
  watch: {
    storedCustomer() {
      this.loadProjects();
    }
  },
  mounted() {
    if (this.storedCustomer) {
      this.loadProjects();
    }
  },
  methods: {
    openBox(box) {
      this.$emit("openBox", box);
    },
    closeBox(box) {
      if (box === "appendService") {
        this.$emit("closeBox", box);
      } else {
        this.errors.endpoint = "";
        this.$emit("closeBox", box);
      }
    },
    loadProjects() {
      if (this.services[0] != null) {
        axios
          .get(
            process.env.VUE_APP_API +
              "/services/" +
              this.services[0].custServiceId +
              "/projects?limit=1000"
          )
          .then(result => {
            const servicesProjects = result.data.data;
            const projectIds = servicesProjects.map(p => p.projectId);
            this.projects = [];
            axios
              .get(
                process.env.VUE_APP_API +
                  "/customers/" +
                  this.storedCustomer.customerId +
                  "/projects?limit=1000&sort=projectName"
              )
              .then(result => {
                this.projects = result.data.data.filter(
                  project => !projectIds.includes(project.projectId)
                );
              })
              .catch(() => {});
          })
          .catch(() => {});
      }
    },
    toggleConfirmation() {
      this.openedConfirmation = this.openedConfirmation ? false : true;
    },
    addRemoveProject(project) {
      if (this.selectedProjects.indexOf(project) == -1) {
        this.selectedProjects.push(project);
      } else {
        this.selectedProjects.splice(this.selectedProjects.indexOf(project), 1);
      }
      //
    },
    runEdit() {
      this.errorsToTranslate = [];
      let promises = [];
      this.services.forEach(item => {
        this.selectedProjects.forEach(project => {
          promises.push(
            axios
              .post(
                process.env.VUE_APP_API +
                  "/services/" +
                  item.custServiceId +
                  "/projects/" +
                  project.projectId +
                  "/assign"
              )
              .then(
                /*result*/ () => {
                  //this.$emit('closeBox', 'appendService');
                }
              )
              .catch(error => {
                this.errorsToTranslate.push(error.data);
              })
          );
        });
      });
      Promise.all(promises).then(() => {
        if (this.errorsToTranslate.length > 0) {
          this.openedError = true;
        } else {
          this.$emit("closeBox", "appendService");
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
